import React from "react";
import styled from "styled-components";
import { Layout } from "../components/layout/Layout";

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: var(--spacing-4);
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: var(--spacing-6);
  color: var(--color-text-primary);
`;

const Section = styled.section`
  margin-bottom: var(--spacing-6);
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  color: var(--color-text-primary);
  margin-bottom: var(--spacing-3);
`;

const Content = styled.div`
  color: var(--color-text-secondary);
  line-height: 1.6;

  p {
    margin-bottom: var(--spacing-3);
  }

  ul {
    margin-bottom: var(--spacing-3);
    padding-left: var(--spacing-4);
  }

  li {
    margin-bottom: var(--spacing-2);
  }
`;

const TermsOfService = () => {
  return (
    <Layout>
      <Container>
        <Title>Conditions Générales d'Utilisation</Title>

        <Section>
          <SectionTitle>1. Acceptation des Conditions</SectionTitle>
          <Content>
            <p>
              En accédant à Cinedelux, vous acceptez d'être lié par ces
              conditions d'utilisation. Si vous n'acceptez pas ces conditions,
              veuillez ne pas utiliser le site.
            </p>
          </Content>
        </Section>

        <Section>
          <SectionTitle>2. Utilisation du Service</SectionTitle>
          <Content>
            <ul>
              <li>Vous devez avoir l'âge légal pour utiliser ce service</li>
              <li>
                Vous êtes responsable de la confidentialité de votre compte
              </li>
              <li>Toute utilisation abusive sera sanctionnée</li>
              <li>Vous vous engagez à fournir des informations exactes</li>
              <li>
                Vous acceptez de ne pas utiliser le service à des fins illégales
              </li>
            </ul>
          </Content>
        </Section>

        <Section>
          <SectionTitle>3. Contenu</SectionTitle>
          <Content>
            <p>
              Le contenu est fourni à titre informatif uniquement. Les droits
              d'auteur appartiennent à leurs propriétaires respectifs. Vous vous
              engagez à ne pas :
            </p>
            <ul>
              <li>Copier ou reproduire le contenu sans autorisation</li>
              <li>Utiliser le contenu à des fins commerciales</li>
              <li>Modifier ou altérer le contenu</li>
            </ul>
          </Content>
        </Section>

        <Section>
          <SectionTitle>4. Responsabilités</SectionTitle>
          <Content>
            <ul>
              <li>Nous ne garantissons pas l'exactitude du contenu</li>
              <li>Nous nous réservons le droit de modifier le service</li>
              <li>Vous utilisez le service à vos propres risques</li>
            </ul>
          </Content>
        </Section>

        <Section>
          <SectionTitle>5. Modifications</SectionTitle>
          <Content>
            <p>
              Nous nous réservons le droit de modifier ces conditions à tout
              moment. Les modifications prennent effet dès leur publication.
            </p>
          </Content>
        </Section>
      </Container>
    </Layout>
  );
};

export default TermsOfService;
